import React, { FC, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OrderDesignSelectContainer } from '@container/OrderDesignSelectContainer';
import { DeleteDesignDialogContainer } from '@container/Dialog';
import { AlertShipDateDialog } from '@component/Dialog';
import { OrderPartsImg } from '@app/react/uikit';
import type { AppState } from '@app/react/reducer';

import { useMediaDesktop, useMediaMobile } from '@app/react/common/useMedia';
import { removeSessionStorage } from '@app/react/hooks/useSessionStorage';
import { makiwaraShipDateAlert } from '@app/react/action/MakiwaraShipDateAlert';
import { showEcHeaderNavi } from '@app/react/common/Function';
import { SCROLL_PERSIST_KEY } from '@app/react/const/variables';

const selectShipDialog = (state: AppState) => state.uiCustomDesign.makiwaraShipDialog;

export const OrderCustomizeDesignContainer: FC = () => {
    const dispatch = useDispatch();
    const isDesktop = useMediaDesktop();
    const isMobile = useMediaMobile();

    const makiwaraShipDialog = useSelector(selectShipDialog);
    const hideMakiwaraShipDialog = useCallback(
        () => dispatch(makiwaraShipDateAlert({ show: false })),
        [dispatch],
    );

    useEffect(() => {
        showEcHeaderNavi(isDesktop, isMobile);
        removeSessionStorage(SCROLL_PERSIST_KEY);
    }, [isDesktop, isMobile]);

    return (
        <div className="customizedesign-container">
            {isDesktop && <OrderPartsImg partsName="HOME" onHelpClick={() => false} />}
            <OrderDesignSelectContainer />
            <DeleteDesignDialogContainer />
            <AlertShipDateDialog
                isOpen={makiwaraShipDialog}
                hide={hideMakiwaraShipDialog}
            />
        </div>
    );
};
